import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RotateIconComponent } from './rotate-icon.component';

@NgModule({
  imports: [CommonModule],
  declarations: [RotateIconComponent],
  exports: [RotateIconComponent],
  providers: [],
})
export class RotateIconModule {}
